export {default} from './game-suggestions-card';
